'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (url) {
    return new Promise(function (resolve, reject) {
        (0, _loadScript2.default)(url, function (err, script) {
            if (err) {
                reject(err);
            } else {
                resolve();
            }
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/loadScript.js
// module id = 232
// module chunks = 0